import React, { useState, useEffect, useCallback } from "react";
import PaymentMethod from "./PaymentMethod";
// import ChooseCardModal from "./ChooseCardModal";
// import AddCardSavings from "./AddCardSavings";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import TextError from "../SelectValue/TextError";
// import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import getServices from "../../Services/get-service";
import { toast } from "react-toastify";

function CreateCard() {
  const navigate = useNavigate();

  // Payment method selection ('WALLET' or 'CARD')
  const [paymentMethod, setPaymentMethod] = useState("WALLET");

  // User cards list (Disabled)
  // const [cards, setCards] = useState([]);
  // const [loadingCards, setLoadingCards] = useState(true);

  // Selected card (Disabled)
  // const [selectedCard, setSelectedCard] = useState(() => {
  //   try {
  //     const stored = sessionStorage.getItem("selectedCard");
  //     return stored ? JSON.parse(stored) : null;
  //   } catch (e) {
  //     return null;
  //   }
  // });

  // Wallet balance
  const [walletBalance, setWalletBalance] = useState(0);

  // Modal open states (Disabled)
  // const [openChooseCard, setOpenChooseCard] = useState(false);
  // const [openAddCard, setOpenAddCard] = useState(false);

  // Fetch cards from API /api/get-my-cards (Disabled)
  /*
  const fetchCards = useCallback(() => {
    setLoadingCards(true);
    getServices
      .getMyCards()
      .then((res) => {
        setLoadingCards(false);
        if (res.data?.statusCode === 200 && Array.isArray(res.data.data)) {
          const cardList = res.data.data;
          setCards(cardList);

          // Update or initialize selected card
          setSelectedCard((prevSelected) => {
            if (cardList.length === 0) {
              sessionStorage.removeItem("selectedCard");
              return null;
            }

            // If user already had a selected card, try to match it
            let matched = null;
            if (prevSelected) {
              matched = cardList.find(
                (c) =>
                  c.id === prevSelected.id ||
                  (c.last4 && c.last4 === prevSelected.last4)
              );
            }

            // Fallback to default card or first card
            if (!matched) {
              matched = cardList.find((c) => c.default) || cardList[0];
            }

            if (matched) {
              sessionStorage.setItem("selectedCard", JSON.stringify(matched));
              if (matched.id !== undefined && matched.id !== null) {
                sessionStorage.setItem("cardId", matched.id);
              }
            } else {
              sessionStorage.removeItem("cardId");
            }
            return matched;
          });
        } else {
          setCards([]);
        }
      })
      .catch(() => {
        setLoadingCards(false);
      });
  }, []);
  */

  useEffect(() => {
    // Ensure payment method is WALLET in storage
    sessionStorage.setItem("paymentMethod", "WALLET");

    // Fetch live wallet balance
    getServices
      .getWalletBalance()
      .then((res) => {
        if (res.data?.statusCode === 200 && res.data.data?.length > 0) {
          setWalletBalance(res.data.data[0].availableBalance);
        }
      })
      .catch(() => {});

    // Getting of the card (Disabled)
    // fetchCards();

    // Re-fetch cards when window regains focus (Disabled)
    // const handleFocus = () => {
    //   fetchCards();
    // };
    // window.addEventListener("focus", handleFocus);
    // return () => window.removeEventListener("focus", handleFocus);
  }, []);

  const handleSelectMethod = (method) => {
    setPaymentMethod(method);
    sessionStorage.setItem("paymentMethod", method);
  };

  /*
  const handleSelectCard = (card) => {
    setSelectedCard(card);
    setPaymentMethod("CARD");
    sessionStorage.setItem("selectedCard", JSON.stringify(card));
    if (card?.id !== undefined && card?.id !== null) {
      sessionStorage.setItem("cardId", card.id);
    }
    sessionStorage.setItem("paymentMethod", "CARD");
    setOpenChooseCard(false);
  };

  const handleCardAdded = () => {
    // Re-fetch cards when add card flow is triggered/completed
    fetchCards();
  };
  */

  const initialValues = {
    amount: sessionStorage.getItem("savingsAmount") || "",
  };

  const validationSchema = Yup.object({
    amount: Yup.string()
      .required("Amount is required")
      .test("is-greater-than-0", "Amount must be greater than 0", (value) => {
        if (!value) return false;
        const num = Number(value.replace(/,/g, ""));
        return !isNaN(num) && num > 0;
      }),
  });

  const onSubmit = (values) => {
    const { amount } = values;

    /*
    if (paymentMethod === "CARD" && !selectedCard) {
      toast.info("Please add or select a card to proceed with card payment.");
      setOpenAddCard(true);
      return;
    }
    */

    sessionStorage.setItem("savingsAmount", amount);
    sessionStorage.setItem("paymentMethod", "WALLET");
    /*
    if (selectedCard) {
      sessionStorage.setItem("selectedCard", JSON.stringify(selectedCard));
      if (selectedCard.id !== undefined && selectedCard.id !== null) {
        sessionStorage.setItem("cardId", selectedCard.id);
      }
    }
    */
    navigate("/save/plan/paymentsummary");
  };

  return (
    <div>
      <div>
        <h1 className="text-back-color2 text-[18px] mb-4 font-[600]">
          How much would you like to get started with?
        </h1>

        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ errors, touched }) => (
            <Form>
              {/* Amount Input */}
              <div className="mb-5">
                <p className="mb-2 text-[13px] font-[500] text-[#1E222B]">
                  Enter amount(NGN)
                </p>
                <Field
                  name="amount"
                  type="text"
                  placeholder="000000"
                  className={`w-full bg-[#FAFBFC] border ${
                    errors.amount && touched.amount
                      ? "border-red-500"
                      : "border-gray-200/90"
                  } rounded-xl px-4 py-3.5 text-[15px] font-[500] text-[#1E222B] placeholder:text-gray-400 focus:outline-none focus:border-[#00BC67] transition`}
                />
                <ErrorMessage name="amount" component={TextError} />
              </div>

              {/* Payment Method Section */}
              <div className="my-4">
                <p className="font-[600] mb-3 text-back-color2 text-[15px]">
                  Select a payment method
                </p>

                <PaymentMethod
                  value={paymentMethod}
                  onChange={handleSelectMethod}
                  // selectedCard={selectedCard}
                  walletBalance={walletBalance}
                />
              </div>

              {/* Action Buttons for Cards (Disabled) */}
              {/* <div className="mt-3 flex items-center gap-3">
                <button
                  type="button"
                  onClick={() => setOpenChooseCard(true)}
                  className="bg-[#18191B] hover:bg-black text-white font-[600] text-[13px] sm:text-[14px] px-4 py-2.5 rounded-xl cursor-pointer transition shadow-2xs"
                >
                  Choose other card
                </button>

                <button
                  type="button"
                  onClick={() => setOpenAddCard(true)}
                  className="bg-[#FAFBFC] hover:bg-gray-100 border border-gray-200/80 text-[#00BC67] font-[600] text-[13px] sm:text-[14px] px-4 py-2.5 rounded-xl cursor-pointer transition flex items-center gap-1 shadow-2xs"
                >
                  <span>New card</span>
                  <AddIcon sx={{ fontSize: 17, color: "#00BC67" }} />
                </button>
              </div> */}

              {/* Next CTA */}
              <div className="mt-8 mb-2">
                <button
                  type="submit"
                  className="w-full py-3.5 rounded-xl bg-[#00BC67] hover:bg-[#00a85c] text-white font-[700] text-[15px] cursor-pointer transition shadow-xs text-center"
                >
                  Next
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>

      {/* Modals for Cards (Disabled) */}
      {/* <ChooseCardModal
        open={openChooseCard}
        handleClose={() => setOpenChooseCard(false)}
        cards={cards}
        selectedCard={selectedCard}
        onSelectCard={handleSelectCard}
        onOpenAddCard={() => {
          setOpenChooseCard(false);
          setOpenAddCard(true);
        }}
        loading={loadingCards}
      /> */}

      {/* <AddCardSavings
        open={openAddCard}
        handleClose={() => {
          setOpenAddCard(false);
          fetchCards();
        }}
        onCardAdded={handleCardAdded}
      /> */}
    </div>
  );
}

export default CreateCard;
